import { useState } from "react";
import PetInformation from "../PetInformation";

const UrinTestForm = () => {
  const [results, setResults] = useState([
    { analyte: "Blood", unit: "RBCs/µl", range: "10-50", result: "" },
    { analyte: "Bilirubin", unit: "mg/dl", range: "0.5-1", result: "" },
    { analyte: "Urobilinogen", unit: "mg/dl", range: "1-4", result: "" },
    { analyte: "Ketone", unit: "mg/dl", range: "10-50", result: "" },
    { analyte: "Protein", unit: "mg/dl", range: "30-100", result: "" },
    { analyte: "Nitrite", unit: "mg/dl", range: "0-0.5", result: "" },
    { analyte: "Glucose", unit: "mg/dl", range: "250-500", result: "" },
    { analyte: "pH", unit: "pH Value", range: "6.5-7", result: "" },
    { analyte: "Specific Gravity", unit: "S.G Value", range: "1.01-1.015", result: "" },
    { analyte: "Leucocytes", unit: "WBC/µl", range: "25-75", result: "" },
  ]);

  const handleChange = (index: number, value: string) => {
    const updatedResults = [...results];
    updatedResults[index].result = value;
    setResults(updatedResults);
  };

  return (
    <div className="overflow-x-auto">
      <PetInformation />

      {/* Colour and Transparency fields */}
      <div className="mb-4">
        <div className="flex gap-4 items-center mb-2">
          <p className="text-xs font-semibold w-[90px]">Colour:</p>
          <input type="text" className="border p-1 text-xs w-[200px]" />
        </div>
        <div className="flex gap-4 items-center">
          <p className="text-xs font-semibold w-[90px]">Transparency:</p>
          <input type="text" className="border p-1 text-xs w-[200px]" />
        </div>
      </div>

      {/* Test Results Table */}
      <table className="min-w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200 print:bg-white">
            <th className="border border-gray-300 p-2 font-bold text-left text-xs">Test Parameter</th>
            <th className="border border-gray-300 p-2 text-left text-xs">Unit</th>
            <th className="border border-gray-300 p-2 text-left text-xs">Range</th>
            <th className="border border-gray-300 p-2 text-left text-xs">Result</th>
          </tr>
        </thead>
        <tbody>
          {results.map((row, index) => (
            <tr key={index} className="text-xs">
              <td className="border border-gray-300 p-2 font-semibold">{row.analyte}</td>
              <td className="border border-gray-300 p-2">{row.unit}</td>
              <td className="border border-gray-300 p-2">{row.range}</td>
              <td className="border border-gray-300 p-2 bg-gray-100 print:bg-white">
                <input
                  type="text"
                  value={row.result}
                  onChange={(e) => handleChange(index, e.target.value)}
                  className="w-full bg-transparent outline-none"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Doctor's Name Input */}
      <div className="flex items-center gap-2 mt-3">
        <p className="text-xs">Doctor's Name:</p>
        <input type="text" className="text-xs w-[400px] border p-1" />
      </div>

      <p className="mt-3 italic text-xs">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default UrinTestForm;
